



$(document).ready(function(){

  $('.menu-drawer__menu.has-submenu.list-menu').prepend('<li><a id=\'HeaderDrawer-all\' href=\'/collections/all\' class=\'menu-drawer__menu-item list-menu__item link link--text focus-inset\'>Všechny produkty</a></li>');
  $('.menu-drawer__menu.has-submenu.list-menu').prepend('<li><a id=\'HeaderDrawer-all\' href=\'/\' class=\'menu-drawer__menu-item list-menu__item link link--text focus-inset\'>Titulní stránka</a></li>');


 $('div.template-search--unique .search__button svg').replaceWith(`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="#ffffff" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
        </svg>
    `);

  let container = $("#FacetsWrapperDesktop");
  let first = container.children("details").first();
  let last = container.children("details").last();

  if (first.length && last.length) {
      first.insertAfter(last); // Prohodí první a poslední prvek
  }
  
  console.log('special_actions_loaded');
  $('.template-search__search .search__input').on('keydown', function(){
      console.log('keypress detected');
      $('.header__icons .search__input').val('');
  });

  $('.grid--5-col-desktop').addClass('grid--4-col-desktop');
  $('.grid--4-col-desktop').removeClass('grid--5-col-desktop');

  var targetElement = $('.metafield-rich_text_field');
  var content = targetElement.html(); // Získání obsahu prvku

  /*
  var updatedContent = content.replace(/podle vašeho přesvědčení\./, "podle vašeho přesvědčení. [break]");
  targetElement.html(updatedContent);
  */

  var content = targetElement.html(); // Získání obsahu prvku

        // Zkontrolujeme, zda obsahuje značku [break]
        if (content.includes("[break]")) {
            // Rozdělení obsahu podle značky [break]
            var parts = content.split("[break]");
            
            // Výpis do konzole pro kontrolu
            console.log("První část:", parts[0].trim());
            console.log("Druhá část:", parts[1].trim());

            // Můžeš je použít, například uložit nebo vložit do jiných prvků
            targetElement.html("<p>" + parts[0].trim() + " <span style='cursor:pointer; color: #6b8e23;' class='anchor'> Zobraz více...</span></p>");

          var newContent = '<div class="anchor-point metafield-rich_text_field" style="display: flex; justify-content: center; width: 100%;"><div style="max-width: 800px; float: left; text-align: center; padding-bottom: 40px;">'+parts[1].trim()+'</div></div>';

          // Vložení HTML před footer
          $('.shopify-section-group-footer-group').before(newContent);

          $(".anchor").click(function(e) {
                e.preventDefault(); // Zabránění výchozímu chování tlačítka/odkazu
                
                // Najdi prvek .anchor-point a odscrolluj k němu
                $('html, body').animate({
                    scrollTop: $(".anchor-point").offset().top
                }, 1000); // 1000 ms = 1 sekunda pro animaci
            });
          
        } else {
            console.log("Značka [break] se v textu nenachází.");
        }
  
  
});

$(window).on('load', function(){

  
  
  setTimeout(function() {
    $('.search__input.field__input').val('');
    $('.rps-search-results-search-bar-input').val('');
    $('.rps-search-results-search-bar-input').removeAttr('value');
    $('.rps_search_results_search_bar_wrapper').remove();
    $('.facets__disclosure-vertical').attr('open','open');
    $('#FacetsWrapperDesktop .facets__and-helptext').remove();
    $('#FacetsWrapperDesktop .facets__summary-label').remove();
  }, 100);
});
